/* eslint-disable no-unused-vars */
import { useContext, useEffect, useState } from 'react';
import { ChooseAudienceManagementContext } from 'contexts';
import { Buttons, ModalBase, Separators } from 'components';
import * as S from './AudienceSettingsTab.styled';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';

export const DeleteAudienceModal = ({ closeModal }) => {
  const {
    cust_aud_name,
    associated_apps,
    associated_campaigns,
    custom_audience_file_upload_el,
    campaigns,
    cust_aud_number,
  } = useContext(ChooseAudienceManagementContext);
  let [isOpen, setIsOpen] = useState(false);
  const [deleteCusAud, deleteCusAudResult] =
    saveCampaignServiceAPI.useDeleteCustomAudienceMutation();

  const handleDeleteAudience = () => {
    console.log('audience to delete', cust_aud_number);
    deleteCusAud(cust_aud_number);
  };

  useEffect(() => {
    if (deleteCusAudResult.isSuccess) {
      setIsOpen(false);
      closeModal();
    }
  }, [deleteCusAudResult]);
  return (
    <>
      <Buttons.SecondaryNormal
        id='delete_audience'
        style={{ width: '150px' }}
        onClick={() => setIsOpen(true)}
      >
        Delete Audience
      </Buttons.SecondaryNormal>
      {isOpen && (
        <ModalBase>
          <div style={{ display: 'flex', padding: '24px', gap: '16px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <S.ModalDeleteTitle>Disconnect?</S.ModalDeleteTitle>
              <S.ModalDeleteText>
                Please note that existing campaign targeting this
                <br /> audience will not be impacted and continue running
              </S.ModalDeleteText>
            </div>
            <S.NotificationIcon>?</S.NotificationIcon>
          </div>
          <Separators type={Separators.separatorTypes.small} />
          <S.Footer>
            <Buttons.SecondaryNormal
              id='close-delete-audience-modal-btn'
              onClick={() => setIsOpen(false)}
              style={{ width: '100%' }}
            >
              Cancel
            </Buttons.SecondaryNormal>
            <Buttons.DestructiveNormal
              id='confirm-delete-audience-btn'
              onClick={handleDeleteAudience}
              style={{ width: '100%' }}
            >
              Disconnect
            </Buttons.DestructiveNormal>
          </S.Footer>
        </ModalBase>
      )}
    </>
  );
};
